import iterateSetProp from "../../../helpers/iterateSetProp";

export function initCustomZoomControlMapHandlers({
  zoomInButton,
  zoomOutButton,
  map,
}: {
  zoomInButton: HTMLElement;
  zoomOutButton: HTMLElement;
  map: google.maps.Map;
}) {
  // Setup the click event listener - zoomIn
  google.maps.event.addDomListener(
    zoomInButton,
    "click",
    function ZoomInHandler() {
      map.setZoom(map.getZoom() + 1);
    },
  );

  // Setup the click event listener - zoomOut
  google.maps.event.addDomListener(
    zoomOutButton,
    "click",
    function ZoomOutHandler() {
      map.setZoom(map.getZoom() - 1);
    },
  );
}

export const controlWrapperStyles = {
  background: "rgb(255, 255, 255)",
  borderRadius: "200px",
  cursor: "pointer",
  textAlign: "center",
  width: "48px",
  height: "113px",
};
export const zoomInStyles = {
  width: "48px",
  height: "56px",
  background: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 13V20H13V13H20V11H13V4H11V11H4V13H11Z' fill='%23164196'/%3E%3C/svg%3E%0A") center no-repeat`,
};
export const decoratorStyles = {
  width: "40px",
  height: "1px",
  margin: "auto",
  background: "#E5E5E5",
};
export const zoomOutStyles = {
  width: "48px",
  height: "56px",
  background: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4 11H20V13H4V11Z' fill='%23164196'/%3E%3C/svg%3E%0A") center no-repeat`,
};

export function customZoomControl(controlDiv: HTMLDivElement) {
  // Creating divs & styles for custom zoom control
  // eslint-disable-next-line no-param-reassign
  controlDiv.style.padding = "24px";
  controlDiv.classList.add("d-none");
  controlDiv.classList.add("d-lg-block");

  // Set CSS for the control wrapper
  const controlWrapper = document.createElement("div");
  iterateSetProp(controlWrapper, "style", controlWrapperStyles);

  controlDiv.appendChild(controlWrapper);

  // Set CSS for the zoomIn
  const zoomInButton = document.createElement("div");
  iterateSetProp(zoomInButton, "style", zoomInStyles);

  controlWrapper.appendChild(zoomInButton);

  const dividerDecoratorDiv = document.createElement("div");
  iterateSetProp(dividerDecoratorDiv, "style", decoratorStyles);

  controlWrapper.appendChild(dividerDecoratorDiv);

  // Set CSS for the zoomOut
  const zoomOutButton = document.createElement("div");
  iterateSetProp(zoomOutButton, "style", zoomOutStyles);

  controlWrapper.appendChild(zoomOutButton);

  return {
    zoomInButton,
    zoomOutButton,
  };
}
